import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Flame, ArrowRight, Lock } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw.length < 6) return toast.error("Password minima 6 caratteri");
    if (newPw !== confirm) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newPw });
      toast.success("Password aggiornata — accedi con la nuova");
      navigate("/login");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore reset");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0F] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <Flame className="w-6 h-6 text-[#FF3B30]" strokeWidth={2.5} />
          <span className="font-display font-black text-2xl uppercase">Fit<span className="text-[#FF3B30]">Command</span></span>
        </div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#E2FF31] mb-3">
          <Lock className="w-3 h-3" /> Reset password
        </div>
        <h1 className="font-display text-5xl font-black uppercase leading-none tracking-tight mb-8">
          Nuova <span className="text-[#FF3B30]">password.</span>
        </h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-xs font-bold tracking-[0.2em] uppercase text-[#A0A0AB] mb-2 block">Codice di reset</label>
            <input
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              data-testid="rp-token"
              className="w-full bg-[#141419] border border-[#2A2A35] px-4 py-3 focus:border-[#FF3B30] focus:outline-none font-mono-alt text-sm"
              placeholder="Incolla il codice ricevuto dal coach"
            />
          </div>
          <div>
            <label className="text-xs font-bold tracking-[0.2em] uppercase text-[#A0A0AB] mb-2 block">Nuova password</label>
            <input
              type="password"
              value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              required
              minLength={6}
              data-testid="rp-new"
              className="w-full bg-[#141419] border border-[#2A2A35] px-4 py-3 focus:border-[#FF3B30] focus:outline-none"
            />
          </div>
          <div>
            <label className="text-xs font-bold tracking-[0.2em] uppercase text-[#A0A0AB] mb-2 block">Ripeti password</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              data-testid="rp-confirm"
              className="w-full bg-[#141419] border border-[#2A2A35] px-4 py-3 focus:border-[#FF3B30] focus:outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="rp-submit"
            className="w-full bg-[#FF3B30] text-white font-bold uppercase tracking-widest py-4 hover:bg-[#e02e24] transition-all flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading ? "Aggiorno..." : "Imposta password"} <ArrowRight className="w-4 h-4" />
          </button>
        </form>
        <div className="mt-6 text-sm text-[#A0A0AB]">
          Torna al{" "}
          <Link to="/login" data-testid="link-back-login" className="text-white hover:text-[#FF3B30] font-bold uppercase tracking-widest text-xs">
            login →
          </Link>
        </div>
      </div>
    </div>
  );
}
